module.exports = __webpack_public_path__ + "static/media/Pin_KeyReplace.fc0d4fe5.svg";